var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('i',{staticClass:"icon",class:_vm.name,style:(_vm.iconStyles)},[_c('svg',{attrs:{"version":"1.1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","viewBox":"0 0 1040 1040","width":"100%","height":"100%"}},[_c('path',{attrs:{"fill":_vm.color,"d":_vm.icons[_vm.name]}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }